import type {
    CollectUnsupportedOrganizationServiceParams,
    OrganizationServiceUnsupportedError,
} from '../types';

const collectUnsupportedOrganizationService = ({
    caughtError,
}: CollectUnsupportedOrganizationServiceParams): OrganizationServiceUnsupportedError => {
    const maybeUnsupported = caughtError as OrganizationServiceUnsupportedError;
    if (maybeUnsupported.code === 'ORGANIZATION_SERVICE_DATA_VERSION_UNSUPPORTED') {
        return maybeUnsupported;
    }
    throw caughtError;
};

export default collectUnsupportedOrganizationService;
